<template>
  <v-container fluid grid-list-xs>
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1 mb-2>
        <span class="green--text">Jugadores</span>
        <span class="ml-3 mr-3">></span>
        <span>Nuevo Jugador</span>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <h4 class="green--text headline">Nuevo Jugador</h4>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-card light>
          <v-card-text>
            <v-form>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 sm3>
                    <v-layout row wrap>
                      <v-flex xs12 class="profile-img-flex">
                        <div 
                          :style="{ 'background-image': 'url('+ playerImage +')' }" 
                          class="player-image"></div>
                        <h6 class="mt-3 text-xs-center">
                          {{ 
                            (currentPlayer.name ? currentPlayer.name : '') 
                          }}
                        </h6>
                        <v-btn
                          class="white--text"
                          color="green"
                          @click="showFilePicker">

                          Seleccionar Imagen
                          <v-icon right dark>cloud_upload</v-icon>
                          <input type="file" @change="readURL($event)" accept="image/*" ref="fileInput" style="display: none">
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>      
                  <v-flex xs12 sm9 ref="form">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          name="name"
                          label="Nombre"
                          prepend-icon="person"
                          light
                          color="green"
                          v-model="currentPlayer.name"
                          :rules="rules.minLength"
                          ref="name"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>  
                  </v-flex>            
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout class="text-xs-right">
              <v-spacer></v-spacer>
              <v-btn flat color="red">Cancelar</v-btn>
              <v-btn color="green" @click="submit">Guardar</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "PlayerForm",
  data() {
    return {
      messageLoader: 'Cargando Información',
      hasErrors: false,
      editMode: false,
      playerImage: '',
      name: '',
      photo: [],
      rules: {
          minLength: [ 
              val => {
                  let res = (val || '').length >= 3 || 'El nombre debe tener al menos 3 caracteres'
                  return res
              }
          ]
      }
    }
  },
  created() {
    if(this.$route.params.playerID) {
        this.editMode = true
        this.find(this.$route.params.playerID)
    }
  },
  computed: {
    ...mapGetters([
      'currentPlayer'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ]),
    form() {
      return {
        name: this.currentPlayer.name
      }
    }
  },
  watch: {
    currentPlayer(player) {
      this.playerImage = player.team.image.original
    }
  },
  methods: {
    ...mapActions([
      'create',
      'find',
      'update'
    ]),
    showFilePicker() {
      this.$refs.fileInput.click()
    },
    readURL(input) {
      if (input.target.files && input.target.files[0]) {
        let reader = new FileReader();

        reader.onload = ((e) => {
          this.playerImage = e.target.result
        })

        reader.readAsDataURL(input.target.files[0]);
        this.photo = input.target.files[0]
      }
    },
    submit() {
      this.hasErrors = false
      let player = {
        'name': this.currentPlayer.name,
        'photo': this.photo ? this.photo : null,
        'team_id': 1
      }

      Object.keys(this.form).forEach(f => {
        if(!this.form[f]){
          this.hasErrors = true
        }

        this.$refs[f].validate(true)
      })

      if(this.hasErrors) return

      if(this.editMode) {
        this.messageLoader = 'Editando Jugador...'
        this.update({ playerID: this.$route.params.playerID, player: player })
      } else {
        this.messageLoader = 'Guardando Jugador...'
        this.create(player)
      }
    }
  }
}
</script>
<style lang="css" scoped>
  .player-image {
    height: 125px;
    width: 125px;
    background-size: contain !important;
    border-radius: 50%;
    background-position: center !important;
    background-color: lightgrey !important;
    background-repeat: no-repeat !important;
  }
  .profile-img-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/players/playerForm.vue